import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import smoothscroll from 'smoothscroll-polyfill';
import '@open-stack/ui/index.css';
import '@adyen/adyen-web/dist/adyen.css';
import './styles/index.scss';
import * as serviceWorker from './services/serviceWorker';
import { Api } from '@orderx/lab/xr/http';
import { AppCache } from './services/app-cache';
import { App } from './components/app/App';
import { ErrorBoundary } from './components/error-boundry/ErrorBoundry';
import { Environment } from './environment';
import { Global } from './module/global/Global';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { enableMapSet } from 'immer';
import { XS } from './xs/XS';
import { SuspenseLoader } from './components/suspense/SuspenseLoader';

enableMapSet();

export const ModuleV2 = React.lazy(() => import('./v2/V2'));

smoothscroll.polyfill();

if (window.location.hostname?.startsWith('www')) {
    window.location.href = window.location.href.replace('www.', '');
}

if (process.env.NODE_ENV === 'development') {
    document.title = `DEV | ${document.title}`;
}

(window as any).APP_VERSION = Environment.APP_VERSION;

Api.setAuthorization(AppCache.get('token'));

Api.setPrefix(
    process.env.NODE_ENV === 'development'
        ? `${window.location.protocol}//${window.location.hostname}:9000`
        : `https://api.orderx.eu`,
);

function Index() {
    const location = useLocation();

    const paths = ['kiosk', 'table', 'pay', 'claim'];

    for (const path of paths) {
        if (location.pathname === `/${path}` || location.pathname.startsWith(`/${path}/`)) {
            return (
                <SuspenseLoader>
                    <ModuleV2 />
                </SuspenseLoader>
            );
        }
    }

    return <App />;
}

ReactDOM.render(
    <StrictMode>
        <BrowserRouter>
            <ErrorBoundary>
                <Global>
                    <XS>
                        <Index />
                    </XS>
                </Global>
            </ErrorBoundary>
        </BrowserRouter>
    </StrictMode>,
    document.getElementById('root'),
);

serviceWorker.unregister();
